export const CLIENT = 'testjwtclientid';
export const CLIENT_CRED = 'XY7kmzoNzl100';
export const TOKEN_NAME = 'access_token';
export const REFRESH_TOKEN_NAME = 'refresh_token';
export const INTERNAL_USER_LOGOUT_URL = 'internal_user_logout_url';